exports = module.exports = require("../../../../node_modules/.0.28.7@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3kOy7YKs5aD2PC6O-eTcBF{overflow:auto;height:300px}._23Fthr9tRaj4HYkBHi-B1v{position:absolute;bottom:0;width:100%;text-align:center}", "", {"version":3,"sources":["/work/moapi/src/routes/project/components/RecordModal.less"],"names":[],"mappings":"AAAA,yBACE,cAAe,AACf,YAAc,CACf,AACD,yBACE,kBAAmB,AACnB,SAAY,AACZ,WAAY,AACZ,iBAAmB,CACpB","file":"RecordModal.less","sourcesContent":[".infiniteContainer {\n  overflow: auto;\n  height: 300px;\n}\n.loadingContainer {\n  position: absolute;\n  bottom: 0px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"infiniteContainer": "_3kOy7YKs5aD2PC6O-eTcBF",
	"loadingContainer": "_23Fthr9tRaj4HYkBHi-B1v"
};


// WEBPACK FOOTER //
// ./node_modules/.0.28.7@css-loader?{"importLoaders":1,"minimize":true,"modules":true,"sourceMap":true}!./node_modules/.2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/fonts/antd/iconfont/""}}!./src/routes/project/components/RecordModal.less